/**
 * FEAT-107 / S-435 — the Social Calendar banner for an account that needs
 * attention: its words, pure so they can be tested.
 */
export interface AccountAttention {
  account_id: number;
  provider: string;
  platform: string;
  display_name: string;
  reason: string | null;
  since: string | null;
  /** Only the owning workspace can end the pause. */
  is_owner: boolean;
  failed_post_ids: string[];
  waiting_post_ids: string[];
}

function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

function providerLabel(provider: string): string {
  return provider ? provider[0]!.toUpperCase() + provider.slice(1) : "The provider";
}

/** "Buffer: Substack (Luis Capobianco) needs attention — 1 post failed, 2 waiting." */
export function attentionSummary(a: AccountAttention): string {
  const failed = a.failed_post_ids.length;
  const waiting = a.waiting_post_ids.length;
  const counts =
    failed + waiting === 0
      ? "no posts are affected in this workspace yet"
      : [failed > 0 ? plural(failed, "post failed", "posts failed") : null, waiting > 0 ? `${waiting} waiting` : null]
          .filter(Boolean)
          .join(", ");
  return `${providerLabel(a.provider)}: ${a.display_name} needs attention — ${counts}.`;
}

/** The confirm text for Discard, naming exactly what goes. */
export function discardConfirm(a: AccountAttention): string {
  const n = a.failed_post_ids.length + a.waiting_post_ids.length;
  return `Delete ${plural(n, "post", "posts")} queued for ${a.display_name}? There is no undo. Posts scheduled further ahead are kept.`;
}
